import { Col, Row } from "antd";

import { PEOPLE_IMAGE, TAILORED_IMAGE, COMMUNITY_IMAGE } from "assets";
import "./styles.scss";

const ApartSection = () => {
  return (
    <section className="apart-section">
      <div className="container apart-section-inner">
        <h2>What Sets Us Apart</h2>
        <Row className="apart-cards-wrapper" gutter={[40, 20]}>
          {apartQualities.map((apartQuality, index) => (
            <Col xs={24} sm={12} md={8} key={index}>
              <ApartCard {...apartQuality} />
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default ApartSection;

const ApartCard = ({ image, desc, title }) => (
  <div className="apart-card">
    <img src={image} alt="apart-image" className="ac-image" />
    <div className="ac-content">
      <h3>{title}</h3>
      <p className="jakarta-sans-font text-black-subtle font-18 line-height-medium">
        {desc}
      </p>
    </div>
  </div>
);

const apartQualities = [
  {
    title: "People-Centric Approach",
    desc: "Agape IT isn’t just a team; we’re a family. Meet our passionate  engineers, designers, and strategists who pour their hearts into every project",
    image: PEOPLE_IMAGE,
  },
  {
    title: "Tailored Solutions",
    desc: "One size doesn’t fit all. We customize our services to fit your unique needs,  whether you’re a startup or an established enterprise. ",
    image: TAILORED_IMAGE,
  },
  {
    title: "Community Impact",
    desc: " Beyond business, we’re committed to giving back. Agape IT sponsors tech  education programs, mentors young talents, and supports local initiatives",
    image: COMMUNITY_IMAGE,
  },
];
